import { render, staticRenderFns } from "./BorderBox11.vue?vue&type=template&id=ab01ba4a"
import script from "./BorderBox11.vue?vue&type=script&lang=js"
export * from "./BorderBox11.vue?vue&type=script&lang=js"
import style0 from "./BorderBox11.vue?vue&type=style&index=0&id=ab01ba4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports